import { createSelector } from "@reduxjs/toolkit";
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { selectAreaInfo } from "./select-area-info";

export const selectAreaIsState = createSelector([selectAreaInfo], (areaInfo) => {
	if (isStringEmpty(areaInfo?.Url)) {
		return false;
	}

	let urlParts = areaInfo?.Url.split("/");

	return urlParts.length === 2;
});